import { render, staticRenderFns } from "./MyEvalution.vue?vue&type=template&id=715a23f3&scoped=true&"
import script from "./MyEvalution.vue?vue&type=script&lang=js&"
export * from "./MyEvalution.vue?vue&type=script&lang=js&"
import style0 from "./MyEvalution.vue?vue&type=style&index=0&id=715a23f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715a23f3",
  null
  
)

export default component.exports